<template>
  <div>
    <div class="wrapper">
      <user-card
        v-if="stateValues.showUserCardDialog"
        pageType="LeadPartyList"
        :leadPartyId="stateValues.leadPartyId"
        :tckn="stateValues.tckn"
        :processId="stateValues.processId"
        @onClickOkCustomerCard="onClickOkCustomerCard"
      />
      <div class="title-wrapper">
        <h1 class="title">
          {{ $t("ActiveProcessReport") }}
        </h1>
      </div>
      <div style="padding-bottom: 10px" class="content-container">
        <div class="content-wrapper">
          <v-row>
            <v-col :cols="4">
              <v-text-field
                style="min-width: 200px"
                v-model="requestData.identityId"
                :label="$t('tckn')"
                @keyup="inputTCKeyUp"
                maxLength="11"
              ></v-text-field>
            </v-col>
            <v-col :cols="4">
              <v-select
                v-model="requestData.assigneeUnitCode"
                :items="unitCodeItems"
                :label="$t('consultantUnit')"
                clearable
              ></v-select>
            </v-col>
            <v-col :cols="4">
              <v-select
                v-model="requestData.assignee"
                :items="consultantItems"
                :label="$t('investmentConsultant')"
                maxLength="255"
                :no-data-text="$t('no_data_found')"
                clearable
              ></v-select>
            </v-col>
            <v-col :cols="4">
              <v-select
                v-model="requestData.processApplicationCode"
                :items="processApplicationCodeItems"
                :label="$t('applicationInformation')"
                :no-data-text="$t('no_data_found')"
                clearable
              ></v-select>
            </v-col>
            <v-col :cols="4">
              <v-select
                v-model="requestData.processDefinitionCode"
                :items="processDefinitionCodeItems"
                :label="$t('processName')"
                :no-data-text="$t('no_data_found')"
                clearable
              ></v-select>
            </v-col>
            <v-col :cols="12">
              <v-btn
                class="ma-2 float-right"
                outlined
                color="indigo"
                @click="openTable"
              >
                {{ $t("filter") }}
              </v-btn>
              <v-btn class="ma-2 float-right" outlined @click="clear">
                {{ $t("clear") }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
      <div
        style="display: flex; justify-content: flex-end; margin-right: 25px"
        v-if="showTable && tableData && tableData.length > 0"
      >
        <export-excel
          style="width: 70px; cursor: pointer; color: darkblue"
          :fields="excel_fields"
          :before-generate="beforeExcel"
          :before-finish="finishExcel"
          :fetch="generateExcelData"
          :name="`Rapor-${new Date().toLocaleString()}.xls`"
        >
          <v-progress-circular
            v-if="excelDownload"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-icon v-else color="blue darken-2">mdi-download</v-icon> Excel
        </export-excel>
      </div>

      <div v-if="showTable" class="content-container" style="padding-top: 10px">
        <div class="content-wrapper">
          <transition name="fade">
            <v-data-table
              :headers="headers"
              :items="tableData"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              :no-data-text="$t('no_data_found')"
              class="elevation-1"
              show-expand
              :loading="loading"
              :footer-props="footerProps"
              :options.sync="pageOptions"
              :server-items-length="totalItems"
              :loading-text="$t('loading')"
              item-key="processReportDTO.id"
            >
              <template v-slot:header>
                <tr>
                  <td></td>
                  <td></td>

                  <td></td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-simple-table
                    style="
                      margin-top: 16px;
                      margin-bottom: 16px;
                      border: 1px solid #3333;
                    "
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{ $t("startDate") }}
                          </th>
                          <th class="text-left">
                            {{ $t("endDate") }}
                          </th>
                          <th class="text-left">
                            {{ $t("consultantUnit") }}
                          </th>
                          <th class="text-left">
                            {{ $t("investmentConsultant") }}
                          </th>
                          <th class="text-left">
                            {{ $t("processStepAndResourceName") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(record, index) in item.expandData"
                          :key="index"
                        >
                          <td>{{ formatDate(record.startTime) }}</td>
                          <td>{{ formatDate(record.endTime) }}</td>
                          <td>
                            {{
                              record.assigneeInfo
                                ? record.assigneeInfo.unitType
                                : ""
                            }}
                          </td>
                          <td>
                            {{
                              record.assigneeInfo
                                ? record.assigneeInfo.fullName
                                : ""
                            }}
                          </td>
                          <td>{{ record.resource.description }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  class="mr-2"
                  @click="viewPdf(item)"
                  v-if="approvalProcess(item)"
                >
                  mdi-pdf-box
                </v-icon>
                <v-icon
                  @click="viewVideo(item)"
                  v-if="item.processReportDTO.roomNameDTO"
                >
                  mdi-video-outline
                </v-icon>
                <v-btn icon @click="onClickCustomerCard(item)">
                  <v-icon :color="'blue darken-2'" size="32"
                    >mdi-account-search</v-icon
                  >
                </v-btn>
              </template>
              <template v-slot:[`item.consultantUnitCode`]="{ item }">
                <div
                  v-if="
                    unitCodeItems.find(
                      pair => pair.value == item.consultantUnitCode
                    ) != null
                  "
                >
                  {{
                    unitCodeItems.find(
                      pair => pair.value == item.consultantUnitCode
                    ).text
                  }}
                </div>
              </template>
              <template v-slot:[`item.partyStatus`]="{ item }">
                {{ formatStatusField(item) }}
              </template>
              <template v-slot:[`item.primaryContactType`]="{ item }">
                {{ formatPrimaryContactTypeField(item.primaryContactType) }}
              </template>
            </v-data-table>
          </transition>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="viewPdfDocument"
      width="70%"
      @click:outside="closeDocument"
    >
      <v-card color="primary" dark v-if="!content">
        <v-card-text>
          {{ $t("documentWaiting") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
      <div class="h-100p pa-4" v-if="content">
        <object id="pdf_viewer" :data="content" type="application/pdf" />
      </div>
    </v-dialog>

    <v-snackbar
      v-model="excelSnackbar"
      :timeout="2000"
      right
      top
      color="primary"
    >
      İndirme başarılı.
    </v-snackbar>
  </div>
</template>

<script>
import VDatetimePicker from "../../components/DatetimePicker";
import UserCard from "../../components/UserCard";
import _ from "underscore";
import AuthorizationApi from "../../service/AuthorizationService";
import LeadPartyApi from "../../service/LeadPartyService";
import moment from "moment";
import DocumentApi from "../../service/DocumentService";
import { BusinessProcessStatus } from "../../constants";
import { parse } from "date-fns";
import ProcessApi from "../../service/ProcessService";

export default {
  name: "ActiveProcessReport",
  components: { VDatetimePicker, UserCard },
  data() {
    var today = new Date();
    today = moment(today).format("DD.MM.yyyy 23:59");

    var today2 = new Date();
    today2 = today2.setMonth(today2.getMonth() - 1);
    today2 = moment(today2).format("DD.MM.yyyy");

    return {
      leadPartyNameList: [],
      processApplicationCodeList: [],
      excelDownload: false,
      excelSnackbar: false,
      stateValues: {
        showUserCardDialog: false,
        leadPartyId: 1,
        processId: "",
        tckn: "",
        note: {}
      },
      requestData: {
        assigneeUnitCode: null,
        assignee: null,
        approver: null,
        identityId: null,
        fullName: null,
        leadIds: [],
        processDefinitionCode: null,
        processApplicationCode: null
      },
      pageOptions: {
        page: 1,
        itemsPerPage: 5
      },
      leadPartySearch: "",
      totalItems: 0,
      userList: [],
      processNameList: [],
      appNameList: [],
      showTable: false,
      expanded: [],
      singleExpand: true,
      tableData: [],
      excelData: [],
      timer: null,
      loading: false,
      documentLoading: false,
      content: null,
      viewPdfDocument: false,
      excel_fields: {
        TCKN: "tckn",
        Ad: "name",
        Soyad: "surname",
        Telefon: "phone",
        Email: "email",
        "Uygulama Bilgisi": "applicationInformation",
        "İletişim Tercihi": {
          field: "primaryContactType",
          callback: value => {
            return this.formatPrimaryContactTypeField(value);
          }
        },
        "Danışman Birimi": "consultantUnitType",
        Danışman: "consultantName",
        "Başlangıç Tarihi/Saati": "startTime",
        "Bitiş Tarih/Saati": "endTime",
        "Süreç Adı": "processName",
        "Süreç Adımı": "processStep",
        "Süreç ID": "processId"
      },
      excel_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  methods: {
    beforeExcel() {
      this.excelDownload = true;
    },
    finishExcel() {
      this.excelSnackbar = true;
      this.excelDownload = false;
    },
    inputKeyUp() {
      this.leadPartySearch = "";
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getData();
      }, 800);
    },
    inputTCKeyUp() {
      if (
        this.requestData.identityId &&
        this.requestData.identityId.length === 11
      ) {
        this.getData();
      }
    },
    openTable() {
      this.showTable = true;
      this.pageOptions.page = 1;
      this.getData();
    },
    apiResponse: function(response, tmpResult = false) {
      const list = response.leadPartyDTOList.content;
      this.totalItems = response.leadPartyDTOList.totalElements;

      list.forEach(item => {
        item.status = this.formatEntityStatusField(item.status);
        item.processReportDTO.startTime = this.formatDate(
          item.processReportDTO.startTime
        );

        item.expandData = [];
        if (
          item.processReportDTO.processTaskReportDTOList.length > 0 &&
          !tmpResult
        ) {
          item.processReportDTO.lastProcessTask =
            item.processReportDTO.processTaskReportDTOList[
              item.processReportDTO.processTaskReportDTOList.length - 1
            ];
          item.expandData.push(
            ...item.processReportDTO.processTaskReportDTOList
          );
        }
      });

      if (tmpResult) {
        this.excelData = list;
      } else {
        this.tableData = list;
      }
      this.loading = false;
    },
    fetchApi: function(requestData, tmpResult = false) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        LeadPartyApi.findallreporting(
          this,
          requestData,
          response => {
            if (response && response.leadPartyDTOList) {
              this.apiResponse(response, tmpResult);
              resolve(true);
            }
          },
          error => {
            this.loading = false;
            this.clear();
            reject(true);
          }
        );
      });
    },
    createRequestData: function(page = null, size = null) {
      let requestData = {
        ...this.requestData,
        identityId:
          this.requestData.identityId != null &&
          this.requestData.identityId.length > 0
            ? this.requestData.identityId
            : null,
        pageSize: size ? size : this.pageOptions.itemsPerPage,
        page: page ? page : this.pageOptions.page - 1,
        leadIds:
          this.requestData.leadIds != null &&
          this.requestData.leadIds.length > 0
            ? this.requestData.leadIds
            : null,
        sorts: [
          {
            fieldName: "startTime",
            sortOrder: "desc"
          }
        ]
      };
      return requestData;
    },

    async getData() {
      let requestData = this.createRequestData();
      await this.fetchApi(requestData);
    },
    formatStatusField(item) {
      if (item.partyStatus) {
        if (item.partyStatus === "Active") {
          return this.$t("identityVerified");
        } else if (item.partyStatus === "Rejected") {
          return this.$t("identityNotVerified");
        } else {
          return this.$t(item.partyStatus);
        }
      }

      return "";
    },
    formatEntityStatusField(status) {
      if (status) {
        if (status === "ACTIVE") {
          return this.$t("entityStatus_active");
        } else if (status === "DELETED") {
          return this.$t("entityStatus_deleted");
        }
      }
    },
    clear() {
      Object.keys(this.requestData).forEach(key => {
        this.requestData[key] = null;
      });

      // this.showTable = false;
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY HH:mm");
    },
    formatPrimaryContactTypeField(primaryContactType) {
      if (primaryContactType != null) {
        return this.$t(primaryContactType.toLowerCase());
      }
      return primaryContactType;
    },
    viewPdf(item) {
      this.viewPdfDocument = true;
      this.retrieveDocument(item.processReportDTO.processId)
        .then(document => {
          if (document) {
            const blob = this.b64toBlob(document);
            this.content = URL.createObjectURL(blob);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewVideo(item) {
      let routeData = this.$router.resolve({
        name: "MeetingVideoViewer",
        query: {
          processId: item.processReportDTO.roomNameDTO.processId,
          timestamp: item.processReportDTO.roomNameDTO.timestamp
        }
      });
      window.open(routeData.href, "_blank");
    },
    b64toBlob(b64Data) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      const sliceSize = 512;

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });
      return blob;
    },

    getAppAndProcessNameList: function() {
      ProcessApi.getAllByVisible(this, response => {
        if (response != null) {
          this.processApplicationCodeList = response.onboardingProcesses;
        }
      });
    },

    getUsers: function() {
      return new Promise(resolve => {
        AuthorizationApi.getUsers(
          this,
          response => {
            if (response != null && response.resultList != null) {
              resolve(
                response.resultList.filter(
                  user => user.domainId == this.$store.getters["user"].domainId
                )
              );
            }
            resolve([]);
          },
          error => {
            resolve([]);
          }
        );
      });
    },
    async retrieveDocument(processId) {
      return new Promise(resolve => {
        DocumentApi.getRecent(
          this,
          "WEB_AGENT",
          processId,
          "OBCF",
          response => {
            if (
              response &&
              response.documentFileWithIdDTO &&
              response.documentFileWithIdDTO.documentFileDTO
            ) {
              resolve(
                response.documentFileWithIdDTO.documentFileDTO.base64Bytes
              );
            }
            resolve();
          },
          error => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    closeDocument() {
      this.content = null;
    },
    approvalProcess(item) {
      if (
        item.processReportDTO &&
        (item.processReportDTO.businessProcessStatus.name ===
          BusinessProcessStatus.APPROVE_SUCCEED ||
          item.processReportDTO.businessProcessStatus.name ===
            BusinessProcessStatus.APPROVE_REJECT ||
          item.processReportDTO.businessProcessStatus.name ===
            BusinessProcessStatus.PRE_APPROVE_REJECT ||
          item.processReportDTO.businessProcessStatus.name ===
            BusinessProcessStatus.PRE_APPROVE_SUCCEED)
      ) {
        return true;
      }
      return false;
    },
    async generateExcelData() {
      let requestData = this.createRequestData(0, this.totalItems);
      await this.fetchApi(requestData, true);

      let excelData = [];
      this.excelData.forEach(item => {
        let manupulateData = item.processReportDTO;
        if (item.processReportDTO) {
          manupulateData.tckn = item.tckn;
          manupulateData.name = item.name;
          manupulateData.surname = item.surname;
          manupulateData.phone = item.phone;
          manupulateData.email = item.email;
          manupulateData.primaryContactType = item.primaryContactType;
          manupulateData.partyStatus = item.partyStatus;
          manupulateData.status = item.status;

          if (
            item.processReportDTO.assigneeInfo !== null &&
            item.processReportDTO.assigneeInfo !== undefined
          ) {
            manupulateData.consultantUnitType =
              item.processReportDTO.assigneeInfo.unitType;
            manupulateData.consultantName =
              item.processReportDTO.assigneeInfo.fullName;
          } else {
            manupulateData.consultantUnitType = "";
            manupulateData.consultantName = "";
          }

          manupulateData.applicationInformation =
            item.processReportDTO.processDefinition.onboardingProcessApplication.description;
          manupulateData.processId = item.processReportDTO.processId;
          manupulateData.processName =
            item.processReportDTO.processDefinition.description;

          excelData.push(JSON.parse(JSON.stringify(manupulateData)));
        }
        if (
          item.processReportDTO.processTaskReportDTOList &&
          item.processReportDTO.processTaskReportDTOList.length > 0
        ) {
          item.processReportDTO.processTaskReportDTOList.forEach(process => {
            manupulateData.tckn = item.tckn;
            manupulateData.name = item.name;
            manupulateData.surname = item.surname;
            manupulateData.phone = item.phone;
            manupulateData.email = item.email;
            manupulateData.primaryContactType = item.primaryContactType;
            manupulateData.partyStatus = item.partyStatus;
            manupulateData.status = item.status;
            manupulateData.startTime = this.formatDate(process.startTime);
            manupulateData.endTime = this.formatDate(process.endTime);
            manupulateData.processStep = process.resource.description;
            if (
              process.assigneeInfo !== null &&
              process.assigneeInfo !== undefined
            ) {
              manupulateData.consultantUnitType = process.assigneeInfo.unitType;
              manupulateData.consultantName = process.assigneeInfo.fullName;
            } else {
              manupulateData.consultantUnitType = "";
              manupulateData.consultantName = "";
            }

            manupulateData.processId = process.processId;
            manupulateData.processName = process.processDefinition
              ? process.processDefinition.description
              : "";
            manupulateData.processStatus = process.businessProcessStatus
              ? process.businessProcessStatus.value
              : "";

            excelData.push(JSON.parse(JSON.stringify(manupulateData)));
          });
        }
      });
      console.log("Excel deneme deneme", excelData);
      return excelData;
    },
    onClickCustomerCard(item) {
      this.stateValues.leadPartyId = item.id;
      this.stateValues.tckn = item.tckn;
      this.stateValues.processId = item.processReportDTO.processId;
      this.stateValues.showUserCardDialog = true;
      this.$emit(
        "onClickCustomerCard",
        item.id,
        item.tckn,
        item.processId,
        stateValues.note
      );
    },
    onClickOkCustomerCard() {
      this.stateValues.showUserCardDialog = false;
      this.stateValues.processId = "";
      this.stateValues.tckn = "";
      this.stateValues.leadPartyId = 0;
      this.stateValues.note = null;
      this.stateValues.showUserCardDialog = false;
    }
  },
  computed: {
    headers() {
      return [
        { text: "", value: "data-table-expand" },
        { text: "", value: "actions", sortable: false },
        {
          text: this.$t("tckn"),
          align: "start",
          sortable: false,
          value: "tckn"
        },
        { text: this.$t("fullName"), value: "fullName" },
        {
          text: this.$t("applicationInformation"),
          value:
            "processReportDTO.processDefinition.onboardingProcessApplication.description"
        },
        {
          text: this.$t("mainProcessName"),
          value: "processReportDTO.processDefinition.description"
        },
        {
          text: this.$t("processStep"),
          value: "processReportDTO.lastProcessTask.resource.description"
        },
        {
          text: this.$t("mainProcessStartTime"),
          value: "processReportDTO.startTime"
        }
      ];
    },

    unitCodeItems: function() {
      let pair = [];
      for (const user of this.userList) {
        if (
          user.unitCode != null &&
          !pair.some(x => x.value === user.unitCode)
        ) {
          pair.push({
            text:
              this.$t(user.unitType) != null
                ? this.$t(user.unitType)
                : user.unitCode,
            value: user.unitCode
          });
        }
      }
      pair.sort(function(a, b) {
        if (b.value == "001") {
          return 1;
        } else if (a.value == "001") {
          return -1;
        } else {
          return a.text.localeCompare(b.text);
        }
      });
      return pair;
    },

    consultantItems: function() {
      let items = [];
      for (const user of this.userList) {
        this.requestData.assignee = null;
        if (
          this.requestData.assigneeUnitCode != null &&
          this.requestData.assigneeUnitCode == user.unitCode
        ) {
          items.push({
            text: user.fullName,
            value: user.fullName
          });
        }
      }
      return items.sort(function(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    },

    entityStatusItems: function() {
      return [
        {
          value: "ACTIVE",
          text: this.$t("entityStatus_active")
        },
        {
          value: "DELETED",
          text: this.$t("entityStatus_deleted")
        }
      ];
    },
    footerProps: function() {
      return {
        "items-per-page-options": [5, 10, 15, 20],
        "items-per-page-text": this.$t("itemsPerPage"),
        "page-text": "{0}-{1}  /  {2}"
      };
    },
    statusItems: function() {
      return [
        { value: "Active", text: this.$t("approved") },
        { value: "Rejected", text: this.$t("notApproved") },
        { value: "Pending", text: this.$t("Pending") },
        { value: "SelfPending", text: this.$t("SelfPending") },
        { value: "SelfSuspended", text: this.$t("SelfSuspended") }
      ];
    },
    processDefinitionCodeItems: function() {
      let items = [];
      for (const processItem of this.processApplicationCodeList) {
        items.push({
          text: processItem.description,
          value: processItem.code
        });
      }
      return items.sort(function(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    },
    processApplicationCodeItems: function() {
      let items = [];
      for (const processItem of this.processApplicationCodeList) {
        items.push({
          text: processItem.onboardingProcessApplication.description,
          value: processItem.onboardingProcessApplication.code
        });
      }
      return items.sort(function(a, b) {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });
    }
  },
  beforeMount: async function() {
    await this.getAppAndProcessNameList();
    this.userList = await this.getUsers();
    LeadPartyApi.findAllNamesLeadParty(
      this,
      this.$store.getters["user"].domainId,
      null,
      [],
      response => {
        if (response != null) {
          this.leadPartyNameList = response.leadPartyDTOList;
        }
      }
    );
  },
  watch: {
    "pageOptions.page": function() {
      this.getData();
    },
    "pageOptions.itemsPerPage": function() {
      this.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#pdf_viewer {
  width: 100%;
  height: 800px;
}

.pdf-wrapper {
  margin-bottom: 150px;

  .document-pdf {
    width: 550px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/report/ActiveProcessReport.vue